<template>
  <div>
    <template>
      <div class="">
        <AccordionHeader
          title="Cover page"
          :isAccordionOpen="isAccordionOpen"
          @onToggleView="toggleAccordion"
          :isDisabled="isDisabled"
          borderStyles="border-bottom: 1px solid #232220;"
        />

        <section
          class="accordion-body"
          :class="{
            active: isAccordionOpen
          }"
          v-if="isAccordionOpen"
        >
          <!-- title region -->
          <div class="title-container custom-block">
            <div class="title">
              <p><strong>Heading</strong></p>
            </div>
            <div class="detail">
              <span class="detail-info">
                Select a title for your redemption page landing.
              </span>
              <div class="customize-section items-center">
                <div class="radio-holder">
                  <radio-button
                    label="Default"
                    value="default-title"
                    v-model="redemptionTitle"
                    @change="handleTitleChange"
                    :isTransparent="true"
                    customStyles="position: relative; bottom: 2px; font-weight: bold; font-size: 0.813rem"
                  />
                </div>

                <div class="caption">
                  <p>
                    Welcome to {{ groupOrderDetails.name }} for
                    {{ groupOrderDetails.teamName }}!
                  </p>
                </div>
              </div>
              <div class="customize-section items-baseline">
                <div class="radio-holder">
                  <radio-button
                    label="Custom"
                    value="custom-title"
                    v-model="redemptionTitle"
                    :isTransparent="true"
                    customStyles="position: relative; bottom: 2px; font-weight: bold; font-size: 0.813rem"
                  />
                </div>
                <div class="input-holder">
                  <textarea
                    @focus="valid.title = false"
                    :class="{ error: valid.title }"
                    id="title-textarea"
                    :disabled="redemptionTitle !== 'custom-title'"
                    rows="1"
                    placeholder="Add title"
                    v-model="customTitle"
                    @blur="handleBlur('title')"
                  ></textarea>

                  <div class="input-info-holder flex justify-between">
                    <small class="error-text" v-if="valid.title">
                      This field is required
                    </small>
                    <span v-else> &nbsp;</span>
                    <!-- <small class="characters-info">
                      {{
                        `${customTitleCharactersLeft} ${
                          customTitleCharactersLeft > 1 ? 'words' : 'word'
                        }  left`
                      }}
                    </small> -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- description section -->
          <div class="description-container custom-block">
            <div class="title">
              <p><strong>Description</strong></p>
            </div>
            <div class="detail">
              <span class="detail-info">
                Select a description for your redemption page landing.
              </span>
              <div class="customize-section">
                <div class="radio-holder">
                  <radio-button
                    @change="handleDescriptionChange"
                    label="Default"
                    value="default-description"
                    v-model="redemptionDescription"
                    :isTransparent="true"
                    customStyles="position: relative; bottom: 2px; font-weight: bold; font-size: 0.813rem"
                  />
                </div>
                <div class="caption">
                  <p>
                    You’ve been invited by {{ groupOrderDetails.teamName }} to
                    redeem free merchandise for [Project Name]. Thank you for
                    being a valued partner.
                  </p>
                </div>
              </div>
              <div class="customize-section">
                <div class="radio-holder">
                  <radio-button
                    label="Custom"
                    value="custom-description"
                    v-model="redemptionDescription"
                    :isTransparent="true"
                    customStyles="position: relative; bottom: 2px; font-weight: bold; font-size: 0.813rem"
                  />
                </div>
                <div class="input-holder">
                  <textarea
                    :class="{
                      error: valid.description,
                      custom: redemptionDescription == 'custom-description'
                    }"
                    :disabled="redemptionDescription !== 'custom-description'"
                    :rows="
                      redemptionDescription == 'custom-description' ? 3 : 1
                    "
                    placeholder="Add description"
                    v-model="customDescription"
                    @blur="handleBlur('description')"
                    @focus="valid.description = false"
                  ></textarea>
                  <small class="characters-info"> </small>
                  <div class="input-info-holder flex justify-between">
                    <small class="error-text" v-if="valid.description">
                      This field is required
                    </small>
                    <span v-else> &nbsp;</span>
                    <!-- <small class="characters-info">
                      {{
                        `${customDescriptionCharactersLeft} ${
                          customDescriptionCharactersLeft > 1 ? 'words' : 'word'
                        }  left`
                      }}
                    </small> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { progressStatus } from '../../../helpers'
import RadioButton from '@/components/Universal/RadioButton.vue'
import AccordionHeader from '../AccordionHeader'
export default {
  name: 'GroupOrderCoverPageSettings',
  props: ['isDisabled'],
  data() {
    return {
      redemptionDescription: 'default-description',
      redemptionTitle: 'default-title',
      customDescription: '',
      customTitle: '',
      valid: {
        password: false,
        title: false,
        sub_title: false,
        description: false
      },
      customTitleMaxCharacters: 10,
      customDescriptionMaxCharacters: 100,
      isAccordionOpen: true
    }
  },

  components: {
    RadioButton,
    AccordionHeader
  },
  created() {
    if (Object.keys(this.groupOrderDetails).length) {
      if (this.groupOrderDetails.enableCustomTitle) {
        this.redemptionTitle = 'custom-title'
        this.customTitle = this.groupOrderDetails.redemptionTitle
      }
      if (this.groupOrderDetails.enableCustomDescription) {
        this.redemptionDescription = 'custom-description'
        this.customDescription = this.groupOrderDetails.redemptionDescription
      }
    }
  },
  methods: {
    updateGroupOrder() {
      this.$store.dispatch('groupOrder/updateGroupOrder', {
        redirect: false,
        showPrices: this.groupOrderDetails.showPrices,
        redemptionTitle: this.customTitle,
        redemptionDescription: this.customDescription,
        // setting values for whether redemption title should be true or false
        enableCustomTitle:
          this.redemptionTitle === 'default-title' ? false : true,
        // setting values for whether redemption description should be true or false
        enableCustomDescription:
          this.redemptionDescription === 'default-description' ? false : true
      })
    },
    toggleAccordion() {
      this.isAccordionOpen = !this.isAccordionOpen
    },
    handleTitleChange() {
      this.valid.title = false
      this.updateGroupOrder()
    },
    handleDescriptionChange() {
      this.valid.description = false
      this.updateGroupOrder()
    },
    handleBlur(type) {
      switch (type) {
        case 'title':
          if (this.customTitle === '') {
            this.valid.title = true
          } else {
            this.updateGroupOrder()
          }
          break
        case 'description':
          if (this.customDescription === '') {
            this.valid.description = true
          } else {
            this.updateGroupOrder()
          }
          break
      }
    },
    titleValidation() {
      let valid
      if (this.redemptionTitle === 'default-title') {
        valid = true
      } else if (
        this.redemptionTitle === 'custom-title' &&
        this.customTitle.length > 0
      ) {
        valid = true
      } else {
        valid = false
      }
      this.valid.title = !valid

      return valid
    },
    descriptionValidation() {
      let valid
      if (this.redemptionDescription === 'default-description') {
        valid = true
      } else if (
        this.redemptionDescription === 'custom-description' &&
        this.customDescription.length > 0
      ) {
        valid = true
      } else {
        valid = false
      }
      this.valid.description = !valid
      return valid
    }
  },
  computed: {
    loadStatus() {
      return progressStatus(this.loadGroupOrder)
    },

    ...mapState({
      loadGroupOrder: state => state.groupOrder.loadGroupOrder,
      groupOrderDetails: state => state.groupOrder.groupOrderDetails,
      creatingGroupOrderStep: state => state.groupOrder.creatingGroupOrderStep
    }),
    validationRules() {
      return {
        customTitle: this.titleValidation(),
        customDescription: this.descriptionValidation()
      }
    },
    customTitleCharactersLeft() {
      if (this.customTitle) {
        return (
          this.customTitleMaxCharacters - this.customTitle.split(' ').length
        )
      } else {
        return this.customTitleMaxCharacters
      }
    },
    customDescriptionCharactersLeft() {
      if (this.customDescription) {
        return (
          this.customDescriptionMaxCharacters -
          this.customDescription.split(' ').length
        )
      } else {
        return this.customDescriptionMaxCharacters
      }
    }
  },
  watch: {
    customTitle(newVal) {
      if (this.customTitleCharactersLeft > 0) {
        this.customTitle = newVal
      } else {
        this.customTitle = newVal
          .split(' ')
          .splice(0, this.customTitleMaxCharacters)
          .join(' ')
      }
    },
    customDescription(newVal) {
      if (this.customDescriptionCharactersLeft > 0) {
        this.customDescription = newVal
      } else {
        this.customDescription = newVal
          .split(' ')
          .splice(0, this.customDescriptionMaxCharacters)
          .join(' ')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/global.scss';

.margin {
  margin-bottom: 1.5rem;
}

.custom-input {
  font-size: 0.813rem !important;
}

.accordion-body {
  height: 0px;
  opacity: 0;
  &.active {
    height: max-content;
    opacity: 1;
    margin-top: 1.7rem;
    margin-bottom: 0.3rem;
  }
}

.holder {
  text-align: left;

  h3 {
    font-size: 1.063rem;
    font-family: $inter;
    color: $main-6;
    padding-bottom: 2rem;
    padding-top: 0.5rem;

    span {
      font-weight: 400;
    }
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.header-region {
  margin: 2.5rem 0;
  border-bottom: 8px solid $main-6;
  p {
    text-align: center;
    padding-bottom: 0.6rem;
    font-size: 1.3rem;
    font-weight: 400;
  }
}

h4 {
  text-align: left;
}
.info-container {
  margin-top: 1.25rem;
  border: 1px solid #232220;
  padding-bottom: 1rem;
}

.domain-container,
.password-container,
.description-container,
.title-container {
  margin: 0rem 0;
  padding: 0 3rem 1rem 3rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 0 1rem 1rem 1rem;
  }
  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 100%;
    .subheading {
      margin-bottom: 1rem;
    }
    p {
      text-align: left;
      font-size: 0.875rem;
      line-height: 24px;
    }
    .detail-info {
      font-size: 0.783rem;
      text-align: left;
      width: max-content;
      display: block;
      margin: 0.25rem 0 1.5rem 0;
      color: #514d43;
      font-weight: 300;
    }
  }
}
.aditional-info {
  margin: 2rem 0rem;
  padding: 0 2.5rem;
  display: flex;
  justify-content: space-between;

  .title {
    width: 25%;
    text-align: left;
  }

  .detail {
    width: 100%;
    p {
      font-size: 0.813rem;
      text-align: left;
      margin-bottom: 1.25rem;
    }
  }

  .custom-fields {
    form {
      width: 100%;
      max-width: 14rem;
      text-align: left;
      margin-bottom: 2rem;

      &.padded {
        margin-bottom: 3rem;
      }

      .form-group {
        display: flex;
        align-items: flex-end;
        gap: 1rem;

        &.mt-3 {
          margin-top: 2rem;
        }
      }
    }

    .remove {
      cursor: pointer;
      display: block;
      width: 20px;
      user-select: none;
    }
  }

  .add-field {
    text-align: left;
    margin-bottom: 1.75rem;
    .button-gemnote--small {
      height: 2.375rem;
      text-transform: unset;
      padding: 0px 2rem !important;
      font-weight: normal;
      width: auto;

      &.custom-button {
        background: inherit;
        color: $onyx;
        text-transform: uppercase;
      }
    }
  }
}
.customize-section {
  display: flex;
  gap: 1rem;
  margin-top: 19px;
  &.password {
    grid-template-columns: 9.5rem 1fr;
    margin-top: 8px;
  }
  .radio-holder {
    width: max-content;
    height: 28px;
    display: flex;
    /* align-items: center; */

    &.password {
      margin-top: 0.5rem;
    }
  }

  &.special-instruction {
    grid-template-columns: 100% 1fr !important;
  }

  .input-holder {
    width: 50%;
  }
  textarea {
    background: inherit;
    font-family: $nunito;
    padding: 2px 0;
    width: 100%;
    display: block;
    /* margin-left: 0; */
    resize: none;
    border: none;
    border-bottom: 1px solid #24292c;
    font-size: 0.875rem;
    line-height: 13px;

    &.custom {
      resize: auto;
    }

    &:focus {
      outline: none;
    }

    &.error {
      border-bottom: 1px solid #da5737;
    }
  }

  .input-info-holder {
    width: 100%;
    .characters-info {
      width: max-content;
    }
    .error-text {
    }
  }

  .characters-info {
    display: block;
    position: relative;
    top: 0px;
    color: rgba(35, 34, 32, 0.5);
    font-size: 0.625rem;
    width: 80%;
    max-width: 90%;
    text-align: right;
  }
  .password-holder {
    width: 50%;
    position: relative;

    input {
      height: 1.75rem;
      padding: 0 0;
      font-size: 0.875rem;
      background: inherit;
      font-family: $nunito;
      border: none;
      border-bottom: 1px solid #24292c;

      &.error {
        border-bottom: 1px solid #da5737;
      }
    }

    span {
      position: absolute;
      top: 9px;
      right: 0;
      font-size: 0.625rem;
      color: #676767;
      cursor: pointer;
    }
  }

  ::placeholder {
    color: #9b9b9b;
    font-size: 0.75rem;
  }
  .error-text {
    color: #da5737;
    font-size: 10px;
  }
}
.row {
  display: flex;
  text-align: left;
  flex-wrap: wrap;
  justify-content: space-between;

  .row-holder {
    width: 33.3%;
    &.first {
      width: 25%;
    }
  }
}

.field {
  font-weight: 700;
  margin: 0.5rem 0;
  font-size: 0.813rem;
}

.button-area {
  margin-top: 3rem;
  display: flex;
  justify-content: center;

  button {
    padding: 0 2rem !important;
    width: auto;
    height: 2.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.domain-content {
  grid-gap: 1rem;
  p {
    margin-top: 0.8rem;
    text-align: left;
  }
}
.allow-domains {
  width: 100%;
}

.title p {
  font-size: 0.913rem;
}

.detail p {
  font-size: 0.813rem !important;
}

@media (max-width: 1100px) {
  .required-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .aditional-info {
    flex-direction: column;
    padding: 2rem;
    transition: 1s ease-in;

    .title {
      width: 100%;
      p {
        margin-bottom: 1rem;
      }
    }

    .detail {
      width: 100%;
    }
  }

  .field {
    flex-basis: 50%;
  }

  .row {
    .row-holder {
      width: 100%;
      &.first {
        width: 100%;
      }
    }
  }
}

@media (max-width: 800px) {
  .customize-section {
    display: block;
  }
  .custom-block {
    display: block;
  }
  .detail {
    width: 100% !important;
  }
  .domain-container {
    display: block;
  }
  .customize-section .password-holder {
    width: 100%;
  }
}
</style>
